"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SelectableListProps = exports.SelectableList = void 0;
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/map"));
var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/from"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/values"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _map2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _react = _interopRequireWildcard(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
var _AuComponent = _interopRequireDefault(require("./AuComponent"));
var _reactIntl = require("react-intl");
var _constants = require("../../constants");
var _Filter = require("./filters/Filter");
var _context5;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "container": "selectable_list-module__container____OoDK",
  "dropdown": "selectable_list-module__dropdown___pTRrb selectable_list-module__container____OoDK",
  "list": "selectable_list-module__list___ot_Ww",
  "limited_height": "selectable_list-module__limited_height___KK42S",
  "item": "selectable_list-module__item___uogVD",
  "link": "selectable_list-module__link___Bo0pb",
  "select": "selectable_list-module__select___pW0g4",
  "wrapper": "selectable_list-module__wrapper___ww6Qv",
  "tooltip": "selectable_list-module__tooltip___MJQCI",
  "selected": "selectable_list-module__selected___NCyzc",
  "separate": "selectable_list-module__separate___sqTIb"
};
const SelectableListProps = exports.SelectableListProps = {
  containerRef: T.object,
  sort: T.oneOf(['asc', 'desc']),
  items: T.arrayOf(T.shape({
    displayId: T.string,
    displayString: T.string,
    value: T.oneOfType([T.string, T.number, T.bool]).isRequired,
    groupIdx: T.number
  })),
  selection: T.arrayOf(_Filter.Filter),
  defaultValue: T.oneOfType([T.string, T.number, T.bool, T.arrayOf(T.oneOfType([T.string, T.number, T.bool]))]),
  multiSelect: T.bool,
  limitedHeight: T.bool,
  canDeselect: T.bool,
  onChange: T.func,
  onInit: T.func,
  dropdown: T.bool
};
const Ul = props => {
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: (0, _classnames.default)(styles.list, {
      [styles.fixed_height]: props.limitedHeight
    })
  }, props.children);
};

/* `containerRef` is a reference to a scrollable container */
const Li = ({
  containerRef,
  selected,
  showDeselect,
  item,
  nextGroup,
  onClick,
  className
}) => {
  const [overflow, setOverflow] = (0, _react.useState)(false);
  const [top, setTop] = (0, _react.useState)(0);
  const toggle = () => onClick(item);
  const link = /*#__PURE__*/_react.default.createElement("a", {
    className: (0, _classnames.default)(styles.link, className),
    onClick: toggle
  }, item.displayString);
  const button = /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
    className: styles.select,
    displayId: `au.${selected && showDeselect ? 'de' : ''}select`,
    onClick: toggle,
    tag: "a"
  });
  return /*#__PURE__*/_react.default.createElement("li", {
    className: (0, _classnames.default)(styles.item, {
      [styles.selected]: selected,
      [styles.separate]: nextGroup
    }),
    onMouseEnter: e => {
      let ellipsis = e.target.offsetWidth < e.target.scrollWidth;
      if (ellipsis && !overflow) {
        setOverflow(true);
      }
      if (containerRef) {
        setTop(e.target.offsetTop - containerRef.scrollTop + 40); // $row_height-desktop: 40px;
      }
    },

    onMouseLeave: () => overflow && setOverflow(false)
  }, link, button, overflow && /*#__PURE__*/_react.default.createElement("div", {
    className: styles.wrapper,
    style: {
      top
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.tooltip
  }, link, button)));
};
class SelectableList extends _AuComponent.default {
  static propTypes = {
    containerRef: T.object,
    sort: T.oneOf(['asc', 'desc']),
    items: T.arrayOf(T.shape({
      displayId: T.string,
      displayString: T.string,
      value: T.oneOfType([T.string, T.number, T.bool]).isRequired,
      groupIdx: T.number
    })),
    selection: T.arrayOf(T.oneOfType([T.string, T.number, T.bool])),
    defaultValue: T.oneOfType([T.string, T.number, T.bool, T.arrayOf(T.oneOfType([T.string, T.number, T.bool]))]),
    multiSelect: T.bool,
    limitedHeight: T.bool,
    canDeselect: T.bool,
    onChange: T.func,
    onInit: T.func
  };
  static defaultProps = {
    items: [],
    selection: [],
    multiSelect: false,
    limitedHeight: false,
    canDeselect: true,
    onChange: _constants.NOOP,
    onInit: _constants.NOOP
  };
  get selectedItems() {
    var _context;
    return (0, _reduce.default)(_context = this.props.items).call(_context, (acc, item) => {
      var _context2;
      if ((0, _includes.default)(_context2 = this.props.selection).call(_context2, item.value)) {
        acc.set(item.value, item);
      }
      return acc;
    }, new _map.default());
  }
  componentDidMount() {
    var _context3;
    const {
      defaultValue
    } = this.props;
    let values = (0, _from.default)((0, _values.default)(_context3 = this.selectedItems).call(_context3));
    if (!values.length && defaultValue) {
      var _context4;
      let fn = (0, _isArray.default)(defaultValue) ? i => (0, _includes.default)(defaultValue).call(defaultValue, i.value) : i => defaultValue === i.value;
      values = (0, _filter.default)(_context4 = this.props.items).call(_context4, fn);
    }
    this.props.onInit(this.props.multiSelect ? values : values[0] || []);
  }
  handleOnClick = (0, _bind.default)(_context5 = this.handleOnClick).call(_context5, this);
  handleOnClick(item) {
    const {
      multiSelect
    } = this.props;
    if (multiSelect) {
      let selectedItems = new _map.default(this.selectedItems);
      if (selectedItems.has(item.value)) {
        // toggle off
        selectedItems.delete(item.value);
      } else {
        // toggle on
        selectedItems.set(item.value, item);
      }
      return this.props.onChange((0, _from.default)((0, _values.default)(selectedItems).call(selectedItems)));
    }
    return this.props.onChange(item);
  }
  render() {
    const {
      sort,
      items,
      containerRef,
      intl,
      className,
      dropdown
    } = this.props;
    let localizedItems = (0, _map2.default)(items).call(items, item => {
      const defaultMessage = item.displayString || item.value;
      if (item.displayId) {
        return {
          ...item,
          displayString: intl.formatMessage({
            id: item.displayId,
            defaultMessage
          })
        };
      }
      return {
        ...item,
        displayString: defaultMessage
      };
    });
    if (sort) {
      (0, _sort.default)(localizedItems).call(localizedItems, (a, b) => b.displayString > a.displayString ? sort === 'asc' ? -1 : 1 : a.displayString > b.displayString ? sort === 'asc' ? 1 : -1 : 0);
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: dropdown ? styles.dropdown : styles.container
    }, /*#__PURE__*/_react.default.createElement(Ul, {
      limitedHeight: this.props.limitedHeight
    }, (0, _map2.default)(localizedItems).call(localizedItems, (item, i) => /*#__PURE__*/_react.default.createElement(Li, {
      key: `list_item-${item.value}`,
      selected: this.selectedItems.has(item.value),
      nextGroup: i > 0 && item.groupIdx && item.groupIdx !== items[i - 1].groupIdx,
      containerRef: containerRef,
      showDeselect: this.props.canDeselect,
      item: item,
      onClick: this.handleOnClick,
      className: className
    }))));
  }
}
exports.SelectableList = SelectableList;
var _default = exports.default = (0, _reactIntl.injectIntl)(SelectableList);